import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'
import axios from "axios";
import {apiRoot} from "@/helpers/variables";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/recover-password',
    name: 'recover-password',
    component: () => import(/* webpackChunkName: "recover-password" */ '../views/RecoverPassword.vue')
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import(/* webpackChunkName: "change-password" */ '../views/ChangePassword.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue')
  },
  {
    path: '/users-manager',
    name: 'users-manager',
    meta: {
      permission: ['Administrator'],
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/UsersManager.vue')
  },
  {
    path: '/pc-products-upload',
    name: 'pc-products-upload',
    meta: {
      permission: ['Administrator', 'GoodsAdmin', ],
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/PCProductsUpload.vue')
  },
  {
    path: '/pc-products',
    name: 'pc-products',
    meta: {
      permission: ['Administrator', 'GoodsAdmin', ],
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/PCProducts.vue')
  },
  {
    path: '/pc-items-for-moderation',
    name: 'pc-items-for-moderation',
    meta: {
      permission: ['Administrator', 'GoodsAdmin', ],
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/RequestsModeration.vue')
  },
  {
    path: '/orders-list',
    name: 'orders-list',
    meta: {
      permission: ['Administrator', 'OrdersAdmin', ],
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/OrdersList.vue')
  },
  {
    path: '/create-order',
    name: 'create-order',
    meta: {
      permission: ['Administrator', 'OrdersAdmin', ],
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/CreateOrder.vue')
  },
  {
    path: '/update-order/:id',
    name: 'update-order',
    meta: {
      permission: ['Administrator', 'OrdersAdmin', ],
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/CreateOrder.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('user').then(response => {
    if (response.uid !== undefined && response.uid !== null) {
      if (response.expiration - (new Date().getTime() / 1000) < 0) {
        store.commit('logOut');
        if (to.path !== '/login') {
          next('/login');
        } else {
          next();
        }
      } else if (response.expiration - (new Date().getTime() / 1000) < (60 * 30)) {
        axios.post(`${apiRoot}users/update-jwt-token`, {}, {
          withCredentials: false,
          crossdomain: true,
          headers: {
            Authorization: `Bearer ${response.token}`,
          }
        }).then(response => {
          store.commit('setUser', response.data);
        }).catch(error => {
          console.error(error)
        });
      }
    }
  })

  if (to.meta.systemId !== undefined && to.meta.systemId !== null) {
    store.commit('setSystemId', {systemId: to.meta.systemId})
  } else {
    store.commit('setSystemId', {systemId: null})
  }

  if (to.meta.permission === undefined || to.meta.permission.length === 0) {
    next()
  }

  store.dispatch('user').then(response => {
    if (to.meta.permission !== undefined && to.meta.permission.filter(value => response.roles.includes(value)).length > 0) {
      next();
    }
  })

  next(false)
})

export default router
